import dayjs from 'dayjs';
import { groupBy } from 'lodash';
import { Fragment } from 'react';
import { Menu, MenuItem } from 'react-bootstrap-typeahead';

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function isUserAnAdmin( user ){
    return (
            user && user.teamMember &&
            (user.teamMember.isAdmin || user.teamMember.role.toLowerCase() == "admin")
        ) || false;
}

export const sortArchivedTenants = (tenantOptions) => {
    return tenantOptions.slice().sort((a, b) => {
        if (a.tenantDetails.archived && !b.tenantDetails.archived) {
            return 1;
        } else if (!a.tenantDetails.archived && b.tenantDetails.archived) {
            return -1;
        } else {
            return 0;
        }
    });
};

export const renderTenantSearchMenu = (results, { newSelectionPrefix, paginationText, renderMenuItemChildren, ...menuProps }, state) => {
    let index = 0;
    const tenantsByArchivedStatus = groupBy(results, tenant => tenant.tenantDetails.archived ? 'archived' : 'active');
    const items = Object.keys(tenantsByArchivedStatus)
        .sort()
        .map(status => {
            const header = status === 'archived' ? 'Archived Tenants' : 'Active Tenants';
            return (
                <Fragment key={status}>
                    {index !== 0 && <Menu.Divider />}
                    {/* <Menu.Header style={{ backgroundColor: "lightgray", color: "black", fontSize: "1em" }}>{header}</Menu.Header> */}
                    {tenantsByArchivedStatus[status].map(tenant => {
                        const item = (
                            <MenuItem key={index} option={tenant} position={index}>
                                {tenant.tenantDetails.archived ? (
                                    tenant.label
                                ) : (
                                    tenant.label
                                )}
                            </MenuItem>
                        );
                        index += 1;
                        return item;
                    })}
                </Fragment>
            );
        });

    return <Menu {...menuProps}>{items}</Menu>;
};


export function getTenantEndOfDayBalance(tenant, financials) {
    let tenantId = tenant.tenantId;
    let amount = 0;
    try {
        if (!financials.tenantHistory[tenantId] || financials.tenantHistory[tenantId].length == 0) {
            amount = tenant.accountBalance ? tenant.accountBalance : 0;
        } else {
            amount = financials.transactionsDict[financials.tenantHistory[tenantId][0]].endOfDayBalance;
        }
    } catch (error) {
        console.log(error);
    }
    return amount;
}


export function getSelectedUtilities(unitUtilities, units, params = { propertyId: "", unitId: "" }) {
    let { propertyId, unitId } = params;
    let selectedUtilities = Object.values(unitUtilities);
    try {

        selectedUtilities = [];

        if (propertyId && !unitId) {
            for (let util of Object.values(unitUtilities)) {
                if (units[util.unit].propertyId == propertyId) {
                    selectedUtilities.push(util)
                }
            }

        } else if (unitId) {
            for (let util of Object.values(unitUtilities)) {
                if (util.unit == unitId) {
                    selectedUtilities.push(util)
                }
            }
        } else {
            selectedUtilities = Object.values(unitUtilities);
        }



    } catch (error) {
        console.log(error);
    }
    return selectedUtilities;
}


export function getAccountsSummary(tenants, financials) {
    let overpaid = 0, balanceDue = 0;
    for (let tenant of tenants) {
        let amount = 0;
        if (financials && financials.tenantHistory && financials.tenantHistory[tenant.tenantId] &&
            financials.tenantHistory[tenant.tenantId].length > 0) {
            amount = financials.transactionsDict[financials.tenantHistory[tenant.tenantId][0]].endOfDayBalance;
        } else if (tenant.accountBalance) {
            amount = tenant.accountBalance;
        }
        if (amount >= 0) {
            overpaid += amount;
        } else {
            balanceDue += Math.abs(amount);
        }
    }
    overpaid = numberWithCommas(overpaid.toFixed(2));
    balanceDue = numberWithCommas(balanceDue.toFixed(2));

    return { overpaid, balanceDue };
}

export function getTransactionsSummary(financials, filteredTransactions = null) {
    let totalInvoice = 0, totalPayment = 0;
    if (financials.transactionsDict && filteredTransactions) {
        for (let tId of filteredTransactions) {
            let transaction = financials.transactionsDict[tId];
            if (transaction.transactionType.toUpperCase() == "INVOICE") {
                totalInvoice += parseFloat(transaction.amount);
            } else if (transaction.transactionType.toUpperCase() == "PAYMENT") {
                totalPayment += parseFloat(transaction.amount);
            }
        }
    }
    totalInvoice = numberWithCommas(totalInvoice.toFixed(2));
    totalPayment = numberWithCommas(totalPayment.toFixed(2));
    return { totalInvoice, totalPayment };
}


export function filterTransactions(financials, transactions, tenants, params = {
    propertyId: "", unitId: "", tenantId: "",
    startDate: null, endDate: null, maxAmount: null, minAmount: null, paymentType: null, invoiceItem: null
}
) {
    try {
        let { propertyId, unitId, tenantId, startDate, endDate, maxAmount, minAmount, paymentType, invoiceItem } = params;
        let tenantFilters = [];
        if (propertyId) {
            tenantFilters.push(tenant => tenant.propertyId == propertyId);
        }
        if (unitId) {
            tenantFilters.push(tenant => tenant.unitId == unitId);
        }
        if (tenantId) {
            tenantFilters.push(tenant => tenant.tenantId == tenantId);
        }

        let transactionFilters = [];
        if (startDate) {
            transactionFilters.push(transaction => transaction.date.getTime() >= startDate.getTime())
        }
        if (endDate) {
            transactionFilters.push(transaction => transaction.date.getTime() <= endDate.getTime())
        }
        if (maxAmount != null && check_if_number(String(maxAmount)) == "") {
            maxAmount = parseFloat(maxAmount);
            transactionFilters.push(transaction => transaction.amount <= maxAmount);
        }

        if (minAmount != null && check_if_number(String(minAmount)) == "") {
            minAmount = parseFloat(minAmount);
            transactionFilters.push(transaction => transaction.amount >= minAmount);
        }

        if (paymentType) {
            transactionFilters.push(transaction => transaction.transactionType != "payment" || transaction.paymentType == paymentType);
        }

        if (invoiceItem) {
            transactionFilters.push(transaction => transaction.transactionType != "invoice" || transaction.category == invoiceItem);
        }

        if (tenantFilters.length > 0) {
            transactions = transactions.filter((transactionId) => {
                let tenant = tenants[financials.transactionsDict[transactionId].tenantId]
                for (let f of tenantFilters) {
                    if (!f(tenant))
                        return false;
                }
                return true;
            });
        }

        if (transactionFilters.length > 0) {
            transactions = transactions.filter((transactionId) => {
                let transaction = financials.transactionsDict[transactionId];
                for (let f of transactionFilters) {
                    if (!f(transaction))
                        return false;
                }
                return true;
            });
        }
    } catch (error) {
        console.log(error);
    }

    return transactions;
}

export function getPropertiesSummary(propertyIds, properties) {
    let vacancies = 0;
    let totalUnits = 0;
    for (let propertyId of propertyIds) {
        if (properties.hasOwnProperty(propertyId)) {
            vacancies += properties[propertyId].vacancies;
            totalUnits += parseInt(properties[propertyId].numUnits);
        }
    }
    vacancies = String(vacancies);
    return { vacancies, totalUnits };

}


export function randomArray(arr) {
    const index = Math.round(Math.random() * (arr.length - 1));
    return arr[index];
}

export function randomAvatar() {
    return "";
}

export function formatDate(d) {
    if(dayjs.isDayjs(d)){
        return d.format("YYYY-MM-DD");
    }
    // TODO: this might affect timezone
    if (d instanceof Date) {
        var month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    return "";

}

export function formatDateTime(d){
    if (d instanceof Date) {
        return formatDate(d) + ", " + d.toLocaleTimeString();
    }
    return "";
}

// solves the issue on iOS devices where the dates are converted to Nan-Nan-Nan
// returns a date object
export function formatDateIOS(date) {
    var t = date.split(/[- :]/);
    var result = new Date(parseInt(t[0]), parseInt(t[1])-1, parseInt(t[2]), parseInt(t[3]), parseInt(t[4]), parseInt(t[5]));
    return result
}

export function removeArrayElement(arr, value) {
    return arr.filter(function (element) {
        return element != value;
    });
}

export const formatDateQueryInput = (date, start=true) => {
    if(date && dayjs.isDayjs(date)){
        let newDate = dayjs(date);
        newDate.set({hour:0,minute:0,second:0,millisecond:0});
        if (!start){
            newDate.add(1, 'days');
        }
        return newDate;
    }
    return date;
}

export function createPenaltyDays(){
    let penaltyDays = [];
    let day = "";
    for(let i = 1; i < 31; i++){
        if(i%10 == 1){
            day = i.toString() + "st"
        }else if(i%10 == 2){
            day = i.toString() + "nd"
        }else if(i%10 == 3){
            day = i.toString() + "rd";
        }else{
            day = i.toString() + "th";
        }
        penaltyDays.push({"value": i, "day": day});
    }
    return penaltyDays;
}

export function convertDateToUserLocalDate(strDate){
    let date  = new Date(strDate);
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

function isFirstCharacterDigit(str){
    return /^\d/.test(str);
}

export function lexicographicalSortingOfUnits(unitA, unitB){
    let aUnitName = unitA.toUpperCase();
    let bUnitName = unitB.toUpperCase();
    let firstCharacterIsDigit = isFirstCharacterDigit(aUnitName) && isFirstCharacterDigit(bUnitName);
    // account for units with no numbers
    let aNum = 0;
    let bNum = 0;
    // Extract numbers from unit names
    if(aUnitName.match(/\d+/)){
        aNum = parseInt(aUnitName.match(/\d+/)[0]) ;
    }
    if(bUnitName.match(/\d+/)){
        bNum = parseInt(bUnitName.match(/\d+/)[0]);
    }
    let aAlpha = aUnitName.replace(/\d+/g, '');
    let bAlpha = bUnitName.replace(/\d+/g, '');

    if(firstCharacterIsDigit){
        // Compare numerical parts first
        if (aNum < bNum) return -1;
        if (aNum > bNum) return 1;
        // Compare alphabetical parts
        if (aAlpha < bAlpha) return -1;
        if (aAlpha > bAlpha) return 1;
    }else{
        // Compare alphabetical parts first
        if (aAlpha < bAlpha) return -1;
        if (aAlpha > bAlpha) return 1;
        // Compare numerical parts
        if (aNum < bNum) return -1;
        if (aNum > bNum) return 1;
    }
    return 0; // if both parts are equal
}